import React from 'react';
import {
  DatePickerInputField,
  InputField,
  CheckboxField,
  PhoneInputField,
} from '../../../../components/FormikFields';
import MultipleFileUpload from '../../../../components/FormikFields/MultipleFileUpload/MultipleFileUpload';
import {
  ACCEPTED_FILE_TYPES,
  ACTING_AS,
  AGREEMENT_TYPE,
  MAX_FILES_COUNT,
  MAX_SIZE_IN_MB,
} from '../../config/constants';

export const amendBillingAgreementFormConfig = ({
  t,
  lang,
  setFieldValue,
  setTouched,
  values,
  actingAs,
  agreementType,
  readOnly,
}) =>
  [
    {
      title: t('special_billing.seller-details'),
      fields: [
        {
          name: 'sellerName',
          label: t('special_billing.name'),
          component: InputField,
          componentProps: {
            disabled: true,
          },
        },
        {
          name: 'sellerPhoneNumber',
          label: t('special_billing.phone-number'),
          component: PhoneInputField,
          componentProps: {
            disabled: actingAs !== ACTING_AS.SELLER,
          },
        },
        {
          name: 'sellerVatNumber',
          label: t('special_billing.vat-account-number'),
          component: InputField,
          componentProps: {
            disabled: true,
          },
        },
        {
          name: 'sellerEmail',
          label: t('special_billing.email-id'),
          component: InputField,
          componentProps: {
            disabled: actingAs !== ACTING_AS.SELLER,
          },
        },
      ],
    },
    agreementType === AGREEMENT_TYPE.SELF && {
      title: t('special_billing.buyer-details'),
      fields: [
        {
          name: 'buyerName',
          label: t('special_billing.name'),
          component: InputField,
          componentProps: {
            disabled: true,
          },
        },
        {
          name: 'buyerVatNumber',
          label: t('special_billing.vat-account-number'),
          component: InputField,
          componentProps: {
            disabled: true,
          },
        },
        {
          name: 'buyerPhoneNumber',
          label: t('special_billing.phone-number'),
          component: PhoneInputField,
          componentProps: {
            disabled: actingAs !== ACTING_AS.BUYER,
          },
        },
        {
          name: 'buyerEmail',
          label: t('special_billing.email-id'),
          component: InputField,
          componentProps: {
            disabled: actingAs !== ACTING_AS.BUYER,
          },
        },
      ],
    },
    agreementType === AGREEMENT_TYPE.THIRD && {
      title: t('special_billing.third-details'),
      fields: [
        {
          name: 'thirdPartyName',
          label: t('special_billing.name'),
          component: InputField,
          componentProps: {
            disabled: true,
          },
        },
        {
          name: 'thirdPartyTinNumber',
          label: t('special_billing.tin-number'),
          component: InputField,
          componentProps: {
            disabled: true,
          },
        },
        {
          name: 'thirdPartyVatNumber',
          label: t('special_billing.vat-account-number'),
          component: InputField,
          componentProps: {
            disabled: true,
          },
        },
        {
          name: 'thirdPartyPhoneNumber',
          label: t('special_billing.phone-number'),
          component: PhoneInputField,
          componentProps: {
            disabled: actingAs !== ACTING_AS.THIRD,
          },
        },
        {
          name: 'thirdPartyEmail',
          label: t('special_billing.email-id'),
          component: InputField,
          componentProps: {
            placeholder: t('special_billing.please-add-the-email-id-here'),
            disabled: actingAs !== ACTING_AS.THIRD,
          },
          required: true,
        },
        {
          name: 'poaDocument',
          label: t('special_billing.upload-the-poa-document'),
          component: MultipleFileUpload,
          componentProps: {
            downloadFileLabel: t('special_billing.download_agreement'),
            fileTypeErrorMessage: t(
              'special_billing.agreement_document_file_type_validation',
            ),
            acceptedFileTypes: ACCEPTED_FILE_TYPES,
            maxFileSizeInMB: MAX_SIZE_IN_MB,
            maximumFiles: MAX_FILES_COUNT,
            values,
            setFieldValue,
            setTouched,
            disabled: true,
          },
        },
      ].filter(Boolean),
    },
    {
      title:
        agreementType === AGREEMENT_TYPE.SELF
          ? t('special_billing.self-billing-agreement-details')
          : t('special_billing.third-party-agreement-details'),
      fields: [
        {
          name: 'agreementStartDate',
          label: t('special_billing.agreement-start-date'),
          component: DatePickerInputField,
          componentProps: {
            className: 'w-100',
            minDate: new Date(),
            dateFormat: 'YYYY-MM-DD',
            displayFormat: 'dd M yy',
            disabled: true,
          },
        },
        {
          name: 'agreementEndDate',
          label: t('special_billing.agreement-end-date'),
          component: DatePickerInputField,
          componentProps: {
            className: 'w-100',
            dateFormat: 'YYYY-MM-DD',
            displayFormat: 'dd M yy',
            minDate: values.agreementStartDate
              ? new Date(values.agreementStartDate)
              : new Date(),
            disabled: !values.agreementStartDate,
          },
        },
        {
          name: 'agreementDocument',
          showTooltip: true,
          label: t('special_billing.upload-the-self-billing-agreement'),
          tooltip: 'special_billing.upload-self-billing-agreement-tooltip',
          component: MultipleFileUpload,
          componentProps: {
            downloadFileLabel: t('special_billing.download_agreement'),
            fileTypeErrorMessage: t(
              'special_billing.agreement_document_file_type_validation',
            ),
            acceptedFileTypes: ACCEPTED_FILE_TYPES,
            maxFileSizeInMB: MAX_SIZE_IN_MB,
            maximumFiles: MAX_FILES_COUNT,
            values,
            setFieldValue,
            setTouched,
            disabled: false,
          },
        },
        {
          name: 'note',
          label: t('special_billing.note'),
          tooltip: 'special_billing.note-tooltip',
          component: InputField,
          componentProps: {
            placeholder: t('special_billing.add-your-note-here'),
            maxlength: 500,
          },
          required: true,
        },
      ],
    },
  ].filter(Boolean);

export const termsAndConditionsFieldConfig = ({
  t,
  lang,
  setFieldValue,
  setTouched,
  values,
  agreementType,
}) => ({
  name: 'termsAndConditions',
  component: CheckboxField,
  componentProps: {
    label: (
      <div>
        {agreementType == AGREEMENT_TYPE.SELF
          ? t('special_billing.supplier_acknowledge')
          : t('special_billing.supplier_acknowledge_third_party')}
      </div>
    ),
  },
  setFieldValue,
  setTouched,
  required: true,
});
